<!-- 邀请码认证 -->
<template>
	<div style="width: 700px;">
		<div style="font-size: 16px;color: #767794;margin-top: 40px;">
			当前认证公司:&nbsp;&nbsp;<span style="cursor:pointer;">{{form1.company_name}}</span>
			<img src="../businessVerificationFunc/assets/img/edit.png" style="vertical-align: bottom;margin-left: 10px;" @click="open" />
		</div>
		<el-form class="custom-form" :model="form1" label-width="80px" label-position="top" :rules="rules"
			ref="authForm">
			<el-form-item label="企业认证码" prop="auth_code" required>
				<el-input v-model="form1.auth_code" placeholder="请输入企业认证码"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between;margin-top: 80px;">
			<el-button style="width: 48%;height: 50px;background: linear-gradient(to right, #5ca4ef, #b240ff);
		    -webkit-background-clip: text;background-clip: text;color: transparent;background-color: rgba(210, 211, 208, 0.1);border: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
          border-radius: 10px;" type="primary" @click="goBack">更换其他验证方式</el-button>
			<el-button style="width: 48%;height: 50px;background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
		  border: transparent;border-radius: 10px;" type="primary" @click="handleNext">开始验证</el-button>
		</div>
	</div>
</template>
<script>
	import {
		getCertification
	} from '@/api/businessVerificationFunc'
	import {
		verifyEnterpriseAuth
	} from '@/api/businessVerification'
	import {   bindCompanyInfo } from '@/api/verify'
	export default {
		data() {
			return {
				form: {},
				form1: {
					company_name: "",
					auth_code: "",
				},
				certifyId: '',
				// 验证规则配置
				rules: {
					auth_code: [{
						required: true,
						message: "请输入企业认证码",
						trigger: "blur"
					}, {
						min: 6,
						max: 50,
						message: "企业认证码长度在6-50个字符之间",
						trigger: "blur",
					}],
				}
			};
		},
		created() {
			console.log('企业认证码认证页面已加载');
			console.log('路由参数:', this.$route.query);
			this.form = JSON.parse(this.$route.query.form)
			this.form1.company_name = this.form.company_name
			try {
				const storedInfo = localStorage.getItem('companyVerifyInfo');
				if (storedInfo) {
					const parsed = JSON.parse(storedInfo);
					this.certifyId = parsed.certifyId || this.certifyId;
					// 合并回填表单，避免丢失用户输入
					if (parsed.formData) {
						this.form = { ...this.form, ...parsed.formData };
					}
				}
			} catch (e) {
				console.warn('恢复本地公司核身信息失败:', e);
			}
		},
		methods: {
			open() {
				this.$prompt('请输入公司名称', '编辑', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({
					value
				}) => {
					getCertification({
						company_name: value,
					}).then(async res => {
						if (res.data.code === 1) {
							this.form1.company_name = res.data.data.company_name
							this.form.company_name = res.data.data.company_name
						} else {
							this.form1.company_name = this.form.company_name
							this.$message({
								type: 'info',
								message: '您输入的公司不存在！'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消修改'
					});
				});
			},
			goBack() {
				this.$confirm('确认更换其他验证方式吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path: '/verifyCompany/businessVerificationFunc',
						query: {
							form: JSON.stringify(this.form),
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			handleNext() {
				// 触发表单验证
				this.$refs.authForm.validate((valid) => {
					if (valid) {
						// 这里调用企业认证码验证API
						this.verifyEnterpriseAuth();
					} else {
						// 验证失败
						console.log("表单验证失败");
						return false;
					}
				});
			},
			verifyEnterpriseAuth() {
				this.$message({
					message: '正在验证企业认证码...',
					type: 'info'
				});
				
				// 调用企业认证码验证API
				verifyEnterpriseAuth({
					company_name: this.form1.company_name,
					auth_code: this.form1.auth_code
				}).then(res => {
					if (res.data.code === 1) {
						bindCompanyInfo({ 
							company_name: this.form1.company_name,
							certify_id: this.certifyId
						}).then(res => {
							if (res.data.code === 1) {
								this.$message({
									type: 'success',
									message: '企业认证码验证成功'
								});
								localStorage.removeItem('companyVerifyInfo');
								this.$router.push({
									path: '/position',
								});
							}else {
								this.$message({
									type: 'error',
									message: res.data.msg || '企业认证失败'
								});
							}
						});
						
					} else {
						this.$message({
							type: 'error',
							message: res.data.msg || '企业认证码验证失败'
						});
					}
				}).catch(err => {
					this.$message({
						type: 'error',
						message: '验证失败，请重试'
					});
				});
			},
		},
	};
</script>
<style scoped>
	::v-deep .el-input-group__append {
		border-radius: 18px;
		font-size: large;
		background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
		color: white;
		margin-left: 20px;
	}

	::v-deep .el-input-group__prepend {
		border-radius: 18px 0px 0px 18px;
		font-size: x-large;
	}

	::v-deep .el-input__inner {
		height: 60px;
		font-size: large;
		border-radius: 18px;
	}

	::v-deep .phone .el-input__inner {
		border-radius: 0px;
	}

	.submitButton {
		width: 180px;
		height: 50px;
		border-radius: 18px;
		background-image: linear-gradient(90deg,
				rgba(126, 180, 235, 1) 0,
				rgba(177, 110, 249, 1) 100%);
		color: white;
		margin-top: 20px;
		font-size: x-large;
		cursor: pointer;
	}

	/* 自定义表单样式 - 字体变大加粗 */
	::v-deep .custom-form {
		/* 调整整体表单的字体大小 */
		font-size: 18px;
		margin-top: 10px;
	}

	/* 表单项标签样式 */
	::v-deep .custom-form .el-form-item__label {
		font-weight: bold;
		/* 标签加粗 */
		font-size: 18px;
		/* 标签字体稍大于输入框 */
		color: #333;
		/* 加深标签颜色 */
	}

	/* 输入框内容样式 */
	::v-deep .custom-form .el-input__inner {
		font-size: 18px;
		/* 输入框字体大小 */
		padding: 10px 15px;
		/* 加大输入框内边距，让整体更大气 */
	}
</style>
